import { Injectable } from '@angular/core';
import { UUID } from '@ird/shared-base';

export enum FormReqType {
  CONTACT = 'Contact',
  AFTERMARKET = 'Aftermarket',
}

export interface ScanSuccessData extends Record<string, string> {
  deviceId: string;
  placementCode: string;
}

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private BU = 'CSS|PST|PFT|PTL';

  public setBusinessUnit(businessUnitName: string): void {
    this.BU = businessUnitName;
  }

  public pushLoginSuccessEvent(user_id: UUID): void {
    this.submitEvent('login_success', { user_id });
  }

  public pushLoginStartEvent(): void {
    this.submitEvent('login_start');
  }

  public pushLoginFailedEvent(): void {
    this.submitEvent('login_failed');
  }

  public pushRegistrationStepEvent(index: number): void {
    this.submitEvent(`registration_screen_${index}`);
  }

  public pushFormOpenEvent(req_type: FormReqType): void {
    this.submitEvent('form_open', { req_type });
  }

  public pushFormSubmitEvent(req_type: FormReqType): void {
    this.submitEvent('form_sent', { req_type });
  }

  public pushRegistrationOpenEvent(): void {
    this.submitEvent('registration_start');
  }

  public pushRegistrationSuccessEvent(email: string): void {
    this.submitEvent('registration_success', { email });
  }

  public pushForgotPasswordOpenEvent(): void {
    this.submitEvent('forgot_password_start');
  }

  public pushForgotPasswordSuccessEvent(email: string): void {
    this.submitEvent('forgot_password_reset_submit', { email });
  }

  public pushCreatePasswordOpenEvent(username: string): void {
    this.submitEvent('forgot_password_email_return', { username });
  }

  public pushCreatePasswordSuccessEvent(username: string): void {
    this.submitEvent('forgot_password_reset_success', { username });
  }

  public pushScanOpenEvent(): void {
    this.submitEvent('scan_start');
  }

  public pushScanSuccessEvent(scanData: ScanSuccessData): void {
    this.submitEvent('scan_success', scanData);
  }

  public pushFileDownloadEvent(event: {
    url: string;
    displayName: string;
    extension: string;
    product: string;
    productCategory: string;
  }): void {
    const { url: file_url, displayName: file_name, product, productCategory, extension: file_extension } = event;
    this.submitEvent('file_downloaded', {
      product_category: productCategory,
      product: product,
      file_name,
      file_extension,
      file_url,
    });
  }

  private submitEvent(event: string, params?: Record<string, string>): void {
    if (typeof window !== 'undefined') {
      const config = { event, BU: this.BU, ...(params || {}) };
      (window as any).dataLayer.push(config);
    }
  }
}
